import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import {
  ActiveCartFacade,
  PromotionLocation,
  PromotionResult,
  Cart,
} from '@spartacus/cart/base/root'
import { Observable } from 'rxjs'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { CommonService } from '../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'app-add-bom-to-quote-cart',
  templateUrl: './add-bom-to-quote-cart.component.html',
  styleUrls: ['./add-bom-to-quote-cart.component.scss'],
})
export class AddBomToQuoteCartComponent implements OnInit {
  iconTypes = ICON_TYPE

  entry$: Observable<any>
  cart$: Observable<Cart>
  loaded$: Observable<boolean>
  increment: boolean
  orderPromotions$: Observable<PromotionResult[]>
  promotionLocation: PromotionLocation = PromotionLocation.ActiveCart

  quantity = 0
  modalIsOpen = false

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  form: FormGroup = new FormGroup({})

  private quantityControl$: Observable<FormControl>
  productlist: any[]

  constructor(
    private launchDialogService: LaunchDialogService,
    protected cartService: ActiveCartFacade,
    public commonService: CommonService,
    public router: Router,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit() {
    this.commonService.getBOMPRoduct.subscribe(
      (BOMPRoducts) => {
        this.productlist = BOMPRoducts
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  dismissModal(reason?: any): void {
    if (reason != 'Continue Shopping' && reason != 'Cross click') {
      this.router.navigate(['quote/cart'])
    }
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.ADD_BOM_TO_QUOTE_CART,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
